export function menuNormalize(row) {
  return {
    idMenu: row.idMenu ?? row.IdMenu ?? row['IdMenu'] ?? 0,
    modulo: row.modulo ?? row.Modulo ?? row['Modulo'] ?? '',
    idModulo: row.idModulo ?? row.IdModulo ?? row['IdModulo'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nivel: row.nivel ?? row.Nivel ?? row['Nivel'] ?? 0,
    idPadre: row.idPadre ?? row.IdPadre ?? row['IdPadre'] ?? null,
    orden: row.orden ?? row.Orden ?? row['Orden'] ?? 0,
    ruta: row.ruta ?? row.Ruta ?? row['Ruta'] ?? null,
    icono: row.icono ?? row.Icono ?? row['Icono'] ?? '',
    idRecurso: row.idRecurso ?? row.IdRecurso ?? row['IdRecurso'] ?? null,
    esRaizModulo: row.esRaizModulo ?? row.EsRaizModulo ?? row['EsRaizModulo'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
